export default __webpack_public_path__ + "static/zenith-0f1e954479615fa54bd823668ff4389f.png";